import { redactSensitiveParams } from "plg/utils/sensitiveUrl";

const MAX_DEPTH = 6;

/** Walks plain objects/arrays and redacts `token=` values in every string; returns the same shape. */
function redactDeep<T>(value: T, depth = 0): T {
  if (typeof value === "string") return redactSensitiveParams(value) as unknown as T;
  if (depth >= MAX_DEPTH || value === null || typeof value !== "object") return value;
  if (Array.isArray(value)) return value.map((v) => redactDeep(v, depth + 1)) as unknown as T;
  const out: Record<string, unknown> = {};
  Object.entries(value as Record<string, unknown>).forEach(([k, v]) => {
    out[k] = redactDeep(v, depth + 1);
  });
  return out as T;
}

/** Sentry beforeSend / beforeSendTransaction: magic-link tokens in URLs never leave the browser. */
export function scrubSentryEvent<T extends object>(event: T): T {
  return redactDeep(event);
}

/** Sentry beforeBreadcrumb: navigation and fetch breadcrumbs carry full URLs. */
export function scrubSentryBreadcrumb<T extends object>(breadcrumb: T): T {
  return redactDeep(breadcrumb);
}
